
<template>
  <v-layout class="networks-view" column>
    <v-flex xs12>
      <div class="networks-view__header">
        <network-header />
      </div>
    </v-flex>
    <v-flex class="networks-view__center-section" xs12>
      <div v-if="isSaveInProgress" class="disabled-overlay"></div>
      <v-layout class="resources-div" column>
        <v-layout class="resources-wrapper">
          <v-flex xs12 sm6 md3 class="resources-column">
            <div v-if="canEditContent" class="resources-column--add-btn" data-qe-id="resource-menu-edit_add_btn"
              @click="openResourceDialog(NetworkConstants.NEW_LINK, NetworkConstants.WAYS_TO_ENGAGE_SMALL, NetworkConstants.MAX_RANGE_FOR_WAYS_TO_ENGAGE)">
              <i class="fas fa-plus-circle mr-2" />
              {{ NetworkConstants.ADD_NEW_LINK }}
            </div>
            <h3>{{ NetworkConstants.WAYS_TO_ENGAGE }}</h3>
            <draggable v-model="networkPageContent.waysToEngage"
              @end="updateDisplayOrder(NetworkConstants.WAYS_TO_ENGAGE_SMALL)" class="drag-area" tag="ul"
                       :options="{animation:200, disabled: isDraggableDisabled}" :ghost-class="'ghost'">
              <li v-for="item in networkPageContent.waysToEngage" :key="item.id">
                <div class="link-container">
                  <a @click="openLink(item)" :class="{ 'link': item.url, 'no-link': !item.url }">{{ item.value }}</a>
                  <i v-if="canEditContent" class="fas fa-pencil-alt"
                    @click="openResourceDialog(NetworkConstants.EDIT, NetworkConstants.WAYS_TO_ENGAGE_SMALL, NetworkConstants.MAX_RANGE_FOR_WAYS_TO_ENGAGE, item)" />
                </div>
              </li>
            </draggable>
          </v-flex>
          <v-flex xs12 sm6 md3 class="resources-column">
            <div v-if="canEditContent" class="resources-column--add-btn" data-qe-id="resource-menu-edit_add_btn"
              @click="openResourceDialog(NetworkConstants.NEW_LINK, NetworkConstants.SIGNATURE_EVENTS_SMALL, NetworkConstants.MAX_RANGE_FOR_SIGNATURE_EVENTS)">
              <i class="fas fa-plus-circle mr-2" />
              {{ NetworkConstants.ADD_NEW_LINK }}
            </div>
            <h3>{{ NetworkConstants.SIGNATURE_EVENTS }}</h3>
            <draggable v-model="networkPageContent.signatureEvents"
              @end="updateDisplayOrder(NetworkConstants.SIGNATURE_EVENTS_SMALL)" class="drag-area" tag="ul"
                       :options="{animation:200, disabled: isDraggableDisabled}" :ghost-class="'ghost'">
              <li v-for="item in networkPageContent.signatureEvents" :key="item.id">
                <div class="link-container">
                  <a @click="openLink(item)" :class="{ 'link': item.url, 'no-link': !item.url }">{{ item.value }}</a>
                  <i v-if="canEditContent" class="fas fa-pencil-alt"
                    @click="openResourceDialog(NetworkConstants.EDIT, NetworkConstants.SIGNATURE_EVENTS_SMALL, NetworkConstants.MAX_RANGE_FOR_SIGNATURE_EVENTS, item)" />
                </div>
              </li>
            </draggable>
            <p>
              {{ NetworkConstants.VISIT_OUR }}
              <a @click="openLiveEventCalendar" class="link-bold">{{
        NetworkConstants.LIVE_EVENT_CALENDAR
      }}</a>
              {{ NetworkConstants.REGISTER_FOR_EVENTS }}
            </p>
          </v-flex>
          <v-flex xs12 sm6 md5 class="resources-column">
            <div v-if="canEditContent" class="resources-column--add-btn" data-qe-id="resource-menu-edit_add_btn"
              @click="openResourceDialog(NetworkConstants.NEW_LINK, NetworkConstants.RESOURCES_SMALL, NetworkConstants.MAX_RANGE_FOR_RESOURCES)">
              <i class="fas fa-plus-circle mr-2" />
              {{ NetworkConstants.ADD_NEW_LINK }}
            </div>
            <h3>{{ NetworkConstants.RESOURCES }}</h3>
            <draggable v-model="networkPageContent.resources"
                       :options="{animation:200, disabled: isDraggableDisabled}"
              @end="updateDisplayOrder(NetworkConstants.RESOURCES_SMALL)" class="drag-area resources-list" tag="ul"
               :ghost-class="'ghost'">
              <li v-for="item in networkPageContent.resources" :key="item.id">
                <div class="link-container">
                  <svg-icon :fileName="item.fileName" :assetLocation="getAssetLocation()" />
                  <a @click="openLink(item)" :class="{ 'link': item.url, 'no-link': !item.url }">{{ item.value }}</a>
                  <i v-if="canEditContent" class="fas fa-pencil-alt"
                    @click="openResourceDialog(NetworkConstants.EDIT, NetworkConstants.RESOURCES_SMALL, NetworkConstants.MAX_RANGE_FOR_RESOURCES, item)" />
                </div>
              </li>
            </draggable>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="industries-section">
      <div v-if="canEditContent" class="industries-section--add-btn" data-qe-id="resource-menu-edit_add_btn"
        @click="openResourceDialog(NetworkConstants.NEW_LINK, NetworkConstants.RELATED_CONTENT_SMALL, NetworkConstants.MAX_RANGE_FOR_RELATED_CONTENT)">
        <i class="fas fa-plus-circle mr-2" />
        {{ NetworkConstants.ADD_NEW_LINK }}
      </div>
      <div class="editable-title">
        <h2 class="industries-title">{{ relatedContentSectionData }}</h2>
        <i v-if="canEditContent" :data-qe-id="`network_header_tagline_dialog`" class="fas fa-pencil-alt edit-icon"
          @click="openEditRelatedContent(networkPageContent.relatedContentSectionName)"></i>
      </div>
      <v-layout row wrap justify-center v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm && !$vuetify.breakpoint.md">
        <draggable v-model="networkPageContent.relatedContent"
          @end="updateDisplayOrder(NetworkConstants.RELATED_CONTENT_SMALL)"
          class="drag-area related-content" tag="div"
          :options="{animation:200, disabled: isDraggableDisabled}"
          :ghost-class="'ghost'">
          <v-flex xs6 sm6 md2 v-for="(item, index) in networkPageContent.relatedContent" :key="item.id" :class="{
              'industry-item': true,
              'no-link': !item.url,
              'centered-single': networkPageContent.relatedContent.length % 5 === 1 && index === networkPageContent.relatedContent.length - 1
            }" @click="openLink(item)">
            <i v-if="canEditContent" class="fas fa-pencil-alt pencil-icon"
              @click.stop="openResourceDialog(NetworkConstants.EDIT, NetworkConstants.RELATED_CONTENT_SMALL, NetworkConstants.MAX_RANGE_FOR_RELATED_CONTENT, item)" />
            <img :src="item.imageURL" :alt="item.value" class="industry-image" />
            <p class="industry-name">{{ item.value }}</p>
          </v-flex>
        </draggable>
      </v-layout>
      <v-layout v-else row wrap justify-center>
        <v-flex xs6 sm6 md2 v-for="(item, index) in networkPageContent.relatedContent" :key="item.id" :class="{
        'industry-item': true,
        'no-link': !item.url,
      }" @click="openLink(item)">
          <i v-if="canEditContent" class="fas fa-pencil-alt pencil-icon"
            @click.stop="openResourceDialog(NetworkConstants.EDIT, NetworkConstants.RELATED_CONTENT_SMALL, NetworkConstants.MAX_RANGE_FOR_RELATED_CONTENT, item)" />
          <img :src="item.imageURL" :alt="item.value" class="industry-image" />
          <p class="industry-name">{{ item.value }}</p>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 >
      <div class="networks-view__about-us">
        <h2 class="networks-view__about-us--title">{{ NetworkConstants.ABOUT_US }}
          <i v-if="canEditContent" class="fas fa-pencil-alt about-us-edit-icon"
            @click="openAboutUs(networkPageContent.aboutUs)" />
        </h2>
        <p class="networks-view__about-us--description">{{ aboutUsData }}</p>
      </div>
    </v-flex>
   <v-dialog v-model="networkMenuEditDialog" content-class="small" persistent scrollable>
      <v-card class="categoryEdit-popup">
        <div v-if="isSaveInProgress" class="disabled-overlay"></div>
        <v-card-title primary-title>
          {{ dialogMessage ? dialogMessage : headerLabel }}
          <i class="fas fa-times" data-qe-id="close_dialog_btn" @click="closeResourceMenuDialog" />
        </v-card-title>
        <v-card-text
          :class="resourceType === NetworkConstants.RESOURCES_SMALL && toggleHeight ? 'inner-scrollbar resource-height' : 'inner-scrollbar'"
          v-if="!dialogMessage">
          <v-form ref="resourceMenuDialog" class="relative-position" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex class="details-view">
  <span v-if="isAboutUs || isRelatedContent" class="select-label">{{ headerLabel }}</span>
  
  <v-textarea 
    v-if="isAboutUs" 
    v-model="networkMenuEditModel.value"
    :maxlength="ypoNetworkValidationRules.ABOUT_US_DESC_MAX_TEXT_LENGTH"
    :placeholder="'Enter About Us information'" 
    :rules="ypoNetworkValidationRules.CATEGORY_LABEL_RULE"
    auto-grow 
    color="ypo_blue" 
    required
  />

  <v-text-field 
    v-if="isRelatedContent" 
    v-model="networkMenuEditModel.value" 
    :maxlength="ypoNetworkValidationRules.RELATED_CONTENT_TITLE_MAX_LENGTH"
    :placeholder="networkMenuEditModel.resourceName"
    :rules="ypoNetworkValidationRules.CATEGORY_LABEL_RULE" 
    autofocus 
    color="ypo_blue" 
    required
  />

  <template v-else>
    <span v-if="!isAboutUs" class="select-label">{{ ypoNetworkMenuDialogFields.DIALOG_CATEGORY_LABEL }}</span>
    <v-text-field 
    v-if="!isAboutUs"
      v-model="networkMenuEditModel.value" 
      :maxlength="resourceType === NetworkConstants.RESOURCES_SMALL
        ? ypoNetworkValidationRules.RESOURCE_LABEL_MAX_TEXT_LENGTH
        : ypoNetworkValidationRules.CATEGORY_NAME_MAX_TEXT_LENGTH"
      :placeholder="networkMenuEditModel.resourceName"
      :rules="ypoNetworkValidationRules.CATEGORY_LABEL_RULE" 
      autofocus 
      color="ypo_blue" 
      required
    />
    <span v-if="!isAboutUs" class="select-label">{{ ypoNetworkMenuDialogFields.DIALOG_LINK }}</span>
    <v-text-field 
    v-if="!isAboutUs"
      v-model="networkMenuEditModel.url" 
      :placeholder="networkMenuEditModel.navigationUrl"
      :rules="urlRules" 
      color="ypo_blue" 
      :required="!isUrlRequired"
    />
    <span v-if="resourceType === NetworkConstants.RESOURCES_SMALL" class="select-label">
      {{ ypoNetworkMenuDialogFields.DIALOG_IMAGE }}
    </span>
    <v-autocomplete 
      v-if="resourceType === NetworkConstants.RESOURCES_SMALL" 
      attach
      :placeholder="getResourceImagesLabel(networkMenuEditModel.fileName)"
      data-qe-id="network-resource-image" 
      v-model="selectedResource" 
      color="ypo_blue"
      :items="resourceImages" 
      item-text="label" 
      item-value="value" 
      required
      v-on:click="toggleResourceHeight" 
      :rules="ypoNetworkValidationRules.IMAGE_RULE"
    >
      <template v-slot:item="data">
        <div class="d-flex align-center">
          <svg-icon :fileName="data.item.value" mt-2/>
          <span>{{ data.item.label }}</span>
        </div>
      </template>
    </v-autocomplete>
    <v-flex pl-2 v-if="resourceType === NetworkConstants.RELATED_CONTENT_SMALL">
      <file-upload 
        class="file-upload secondary_btn" 
        extensions="gif,jpg,jpeg,png,webp"
        accept="image/png, image/gif, image/jpeg" 
        :multiple="false" 
        :maximum="1" 
        v-model="files"
        @input="handleUploadedFiles" 
        ref="upload"
      >
        <span class="create-feature-event__photo-button_title">{{ ypoNetworkMenuDialogFields.ADD_PHOTO }}</span>
        <v-icon size="20" color="ypo_blue">photo</v-icon>
      </file-upload>
      <span class="image-name" v-if="uploadedImageName">{{ uploadedImageName }}</span>
      <span class="image-name" v-else>{{ networkMenuEditModel.fileName }}</span>
      <v-img 
        v-if="uploadedImageUrl || networkMenuEditModel.imageURL" 
        class="item-img" 
        ref="previewImage"
        cover 
        height="100" 
        :src="uploadedImageUrl || networkMenuEditModel.imageURL"
      ></v-img>
    </v-flex>
  </template>
</v-flex>


            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-layout pb-2 pt-1 row wrap class="relative-position" v-if="!dialogMessage">
            <v-flex pa-3 v-if="deleteTriggered">
              <v-layout row pt-3 pb-2>
                <v-flex xs-6 pt-1 class="bold-font">
                  {{ NetworkConstants.DELETE_CONFIRMATION_MESSAGE }}
                </v-flex>
                <v-flex xs-6 class="text-right">
                  <v-btn class="primary_btn transparent" data-qe-id="cancel_dialog_btn" flat small
                    @click="deleteTriggered = false">
                    {{ appCommonConstants.CANCEL }}
                  </v-btn>
                  <v-btn class="primary_btn" data-qe-id="save_dialog_btn"
                    @click="confirmDeleteAction(networkMenuEditModel)">
                    {{ appCommonConstants.CONFIRM }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex pa-3 text-xs-right v-else>
              <v-btn v-if="!isAboutUs && !isRelatedContent && displayDeleteButton" class="primary_btn transparent"
                data-qe-id="delete_dialog_btn" flat small @click="deleteTriggered = true">
                {{ appCommonConstants.DELETE }}
              </v-btn>
              <v-btn class="primary_btn transparent" data-qe-id="cancel_dialog_btn" flat small
                @click="closeResourceMenuDialog">
                {{ appCommonConstants.CANCEL }}
              </v-btn>
              <v-btn v-if="!isAboutUs" class="primary_btn" data-qe-id="save_dialog_btn" :disabled="!isFormValid"
                @click="saveNetworkMenuAction">
                {{ appCommonConstants.SAVE }}
              </v-btn>
              <v-btn v-if="isAboutUs" class="primary_btn" data-qe-id="save_dialog_btn" :disabled="!isFormValid"
                @click="saveAboutUs">
                {{ appCommonConstants.SAVE }}
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout pb-2 pt-1 row wrap class="relative-position" v-if="dialogMessage">
            <v-flex pa-3 text-xs-right>
              <v-btn class="primary_btn" data-qe-id="close_dialog_btn" @click="closeResourceMenuDialog">
                {{ appCommonConstants.CLOSE }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  NetworkConstants,
  getNetworkMenuModel,
  ypoNetworkMenuDialogFields,
  ypoNetworkValidationRules,
  getResourceImagesNames,
  getResourceImagesLabel,
  resourceTypeHeaders
} from "./NetworkConstants";
import draggable from 'vuedraggable';
import { storeGetters } from "@/store/storeGetters.constant";
import { storeAction } from "@/store/storeActions.constant";
import NetworkHeader from "@/components/NetworkPage/NetworkHeader.vue";
import { eventDirectoryPageConstant } from "../EventDirectoryPage/eventDirectoryPage.constants";
import { createCommunityFilter } from "@/components/ChapterPage/communityCommon.constant";
import { routerNames, appCommonConstants } from "../appCommon.constants";
import { openHtmlLink } from "@/common/utils/utils";
import { createFormDataForSelectedFiles } from "@/common/utils/fileUploader";
import StatusBar from "@/components/StatusBar/StatusBar";
import SvgIcon from "@/components/NetworkPage/SvgIcon.vue";
import PhotoUploader from "@/components/PhotoUploader/PhotoUploader";
import PhotoReview from '@/components/PhotoUploader/PhotoReview';
import uniqBy from 'lodash/uniqBy';
import FileUpload from 'vue-upload-component';

export default {
  name: "NetworkLandingPage",
  components: {
    PhotoReview,
    FileUpload,
    PhotoUploader,
    SvgIcon,
    NetworkHeader,
    StatusBar,
    draggable,
  },
  data() {
    return {
      uploadedImageUrl: '',
      isRelatedContent: false,
      uploadedImageName: '',
      isAboutUs: false,
      NetworkConstants,
      appCommonConstants,
      defaultFilterKey: eventDirectoryPageConstant.constant.myChapterDefaultFilter.parentKey,
      headerLabel: "",
      isSaveInProgress: false,
      valid: false,
      displayDeleteButton: false,
      deleteTriggered: false,
      networkMenuEditDialog: false,
      networkMenuEditModel: getNetworkMenuModel(),
      ypoNetworkMenuDialogFields,
      ypoNetworkValidationRules,
      files: [],
      resourceType: "",
      dialogMessage: "",
      getResourceImagesLabel,
      resourceImages: getResourceImagesNames(),
      selectedResource: "",
      toggleHeight: false,
      imagePreviewUrl: '',
      aboutUs: {
        id: "",
        categoryId: "",
        value: "",
        isActive: true,
        displayOrder: 1
      },
      relatedContentTitle: {
        id: "",
        categoryId: "",
        value: "",
      }
    };
  },
  created() {
    if (this.$route.params && this.$route.params.communityId) {
      this.getNetworkPageContent(this.$route.params.communityId);
    }
  },
  watch: {
    'networkPageContent.waysToEngage.length': function (newLength) {
      this.displayDeleteButton = newLength >= 2;
    }
  },
  methods: {
    ...mapActions({
      getNetworkPageContent: `network/${storeAction.getNetworkPageContent}`,
      saveYpoNetworkCategories: `network/${storeAction.saveYpoNetworkCategories}`,
      modifyDisplayOrderNetworkCategories: `network/${storeAction.modifyDisplayOrderNetworkCategories}`,
      updateRelatedContentData: `network/${storeAction.updateRelatedContentData}`,
    }),
    toggleResourceHeight() {
      this.toggleHeight = true;
    },
    openLiveEventCalendar() {
      this.toggleHeight = false;
      const filters = [];
      const communityData = this.communityInfo;
      this.defaultFilterKey =
        (communityData.communityType.toLowerCase() === "chapter" ||
          communityData.communityType.toLowerCase() === "network") &&
          communityData.isMember
          ? `my${communityData.communityType}s`
          : eventDirectoryPageConstant.constant.myChapterDefaultFilter.parentKey;
      filters.push(createCommunityFilter(communityData));
      const eventFilters = {
        [this.defaultFilterKey]: filters,
      };
      this.$router.push({
        path: `/${routerNames.YPO_EVENTS}`,
        query: {
          eventFilters: JSON.stringify(eventFilters),
          eventSearchText: "",
        },
      });
    },
    openLink(link) {
      if (link.url) {
        openHtmlLink(link.url, this.isMobileAppBrowser);
      }
    },

  openAboutUs(aboutUsContent) {
    this.isRelatedContent = false;
    if(!aboutUsContent) {
      this.aboutUs.categoryId = this.getCategoryId(NetworkConstants.ABOUT_US_SMALL);
    }
    this.openDialog('aboutUs', aboutUsContent || this.aboutUs);
  },

  openEditRelatedContent(relatedContentValue) {
    if(!relatedContentValue) {
      this.relatedContentTitle.categoryId = this.getCategoryId(this.NetworkConstants.RELATED_CONTENT_SECTION_NAME);
      relatedContentValue = this.relatedContentTitle;
      this.relatedContentTitle.value = this.NetworkConstants.RELATED_CONTENT;
    }
    this.openDialog(this.NetworkConstants.RELATED_CONTENT_SMALL, relatedContentValue);
  },
  openDialog(type, content) {
    this.networkMenuEditDialog = true;
    this.headerLabel = type === 'aboutUs' ? 'About Us' : 'Edit Network Content';
    
    if (type === NetworkConstants.ABOUT_US_SMALL) {
      this.isAboutUs = true;
      this.isRelatedContent = false;
      this.aboutUs = content;
      this.networkMenuEditModel = { ...this.aboutUs };
    } else if (type === 'relatedContent') {
      this.isRelatedContent = true;
      this.isAboutUs = false;
      this.networkMenuEditModel = { 
        ...content, 
        isActive: true, 
        displayOrder: 0, 
        communityId: this.$route.params.communityId 
      };
    }
  },
  getAssetLocation() {
      return 'ypoNetworksSvgImg' ;
    },
    openResourceDialog(type, resourceType, maxLinkLimit, item = null) {
      if (this.networkPageContent[resourceType].length >= maxLinkLimit && type === NetworkConstants.NEW_LINK) {
        this.networkMenuEditDialog = true;
        this.dialogMessage = NetworkConstants.MAX_LINK_LIMIT;
        this.resourceType = resourceType;
        this.uploadedImageName = this.networkMenuEditModel.fileName;
      } else {
        this.dialogMessage = '';
        this.networkMenuEditDialog = true;
        this.resourceType = resourceType;
        const communityId = this.$route.params.communityId;
        const categoryData = this.networkPageContent[resourceType] || [];
        const categoryId = categoryData.length ? categoryData[0].categoryId : this.getCategoryId(resourceType);
        const categoryName = categoryData.length ? categoryData[0].categoryName : '';
        const displayOrder = categoryData.length + 1;

        if (type === NetworkConstants.EDIT && item) {
          this.networkMenuEditModel = { ...item, communityId: this.$route.params.communityId };
          this.headerLabel = this.networkMenuEditModel.value;
          this.displayDeleteButton = categoryData.length >= 2;
          this.selectedResource = this.networkMenuEditModel.fileName;
        } else {
          this.displayDeleteButton = false;
          this.networkMenuEditModel = {
            ...getNetworkMenuModel(),
            displayOrder,
            communityId,
            categoryId,
            categoryName,
          };
          this.headerLabel = resourceTypeHeaders[resourceType] || ypoNetworkMenuDialogFields.DIALOG_NEW_NETWORK_LABEL;
        }
      }
    },
    closeResourceMenuDialog() {
      this.toggleHeight = false;
      this.isSaveInProgress = false;
      this.networkMenuEditDialog = false;
      this.deleteTriggered = false;
      this.networkMenuEditModel = getNetworkMenuModel();
      this.dialogMessage = '';
      this.isAboutUs = false;
      this.isRelatedContent = false;
      this.selectedResource = "";
      this.resourceType = '';
      this.files = [];
      this.uploadedImageUrl = '';
      this.removeFileFromUploader(0);
    },
    confirmDeleteAction(resource) {
      const saveData = { ...resource, isActive: false };
      this.saveYpoNetworkCategories(saveData)
        .then(() => {
          this.isSaveInProgress = false;
          this.getNetworkPageContent(this.$route.params.communityId);
          this.closeResourceMenuDialog();
        })
        .catch(() => {
          this.isSaveInProgress = false;
          this.getNetworkPageContent(this.$route.params.communityId);
          this.closeResourceMenuDialog();
        });
      this.toggleHeight = false;
    },
    saveNetworkMenuAction() {
      this.isSaveInProgress = true;
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (this.resourceType === NetworkConstants.RELATED_CONTENT_SMALL) {
        const formData = createFormDataForSelectedFiles([...this.files]);
        formData.append('Id', this.networkMenuEditModel.id || '');
        formData.append('CommunityId', this.$route.params.communityId);
        formData.append('categoryId', this.networkMenuEditModel.categoryId || '');
        formData.append('Value', this.networkMenuEditModel.value);
        if (emailPattern.test(this.networkMenuEditModel.url) && !this.networkMenuEditModel.url.startsWith('mailto:')) {
          this.networkMenuEditModel.url = `mailto:${this.networkMenuEditModel.url}`;
        }
        formData.append('url', this.networkMenuEditModel.url || '');
        formData.append('displayOrder', this.networkMenuEditModel.displayOrder || 1);
        formData.append('isActive', true);
        formData.append('fileName', this.uploadedImageName || this.networkMenuEditModel.fileName);

        if (this.files.length === 0 && this.networkMenuEditModel.imageURL) {
          formData.append('imageURL', this.networkMenuEditModel.imageURL);
        }

        this.updateRelatedContentData(formData)
          .then(() => {
            this.handleSaveSuccess();
          })
          .catch(() => {
            this.handleSaveError();
          });
      } else {
        const saveData = { ...this.networkMenuEditModel };
        if (emailPattern.test(saveData.url) && !saveData.url.startsWith('mailto:')) {
          saveData.url = `mailto:${saveData.url}`;
        }
        if (this.resourceType === 'resources') {
          saveData.fileName = this.selectedResource ? this.selectedResource : saveData.fileName;
        }
        this.saveYpoNetworkCategories(saveData)
          .then(() => {
            this.isSaveInProgress = false;
            this.selectedResource = "";
            this.closeResourceMenuDialog();
          })
          .catch(() => {
            this.isSaveInProgress = false;
            this.selectedResource = "";
            this.closeResourceMenuDialog();
          });
      }
      this.toggleHeight = false;
    },

    handleSaveSuccess() {
      this.isSaveInProgress = false;
      this.selectedResource = "";
      this.closeResourceMenuDialog();
      if (this.resourceType === NetworkConstants.RELATED_CONTENT_SMALL) {
        this.removeFileFromUploader(0);
      }
    },

    handleSaveError() {
      this.isSaveInProgress = false;
      this.selectedResource = "";
      this.closeResourceMenuDialog();
    }
    ,
    handleUploadedFiles(selectedFiles) {
      if (selectedFiles && selectedFiles.length) {
        this.files = uniqBy([...this.files, ...selectedFiles], 'name');
        const file = this.files[0];
        if (file && file.file && file.file instanceof File) {
          this.uploadedImageName = file.file.name;
          this.uploadedImageUrl = URL.createObjectURL(file.file);
        } else {
          console.error('Selected item is not a File object');
        }
      }
    },
    removeFileFromUploader(fileIndex) {
      this.files.splice(fileIndex, 1);
      if (this.files.length === 0) {
        this.uploadedImageName = '';
      } else {
        this.uploadedImageName = this.files[0].name;
        this.uploadedImageUrl = '';
      }
    },

    saveAboutUs() {
      this.isSaveInProgress = true;
      this.networkMenuEditModel = { ...this.networkMenuEditModel, communityId: this.$route.params.communityId };
      this.saveYpoNetworkCategories(this.networkMenuEditModel)
        .then(() => {
          this.isSaveInProgress = false;
          this.closeResourceMenuDialog();
        })
        .catch(() => {
          this.isSaveInProgress = false;
          this.closeResourceMenuDialog();
        });
    },
    updateDisplayOrder(resourceType) {
      this.isSaveInProgress = true;
      const updatedContent = this.networkPageContent[resourceType].map((item, index) => {
        const updatedItem = { ...item };
        updatedItem.displayOrder = index + 1;
        updatedItem.communityId = this.$route.params.communityId;
        if (resourceType !== NetworkConstants.RESOURCES_SMALL) {
          updatedItem.fileName = item.fileName || null;
        }
        return updatedItem;
      });

      const saveData = [...updatedContent];

      this.modifyDisplayOrderNetworkCategories(saveData)
        .then(() => {
          this.isSaveInProgress = false;
          this.closeResourceMenuDialog();
        })
        .catch((err) => {
          this.isSaveInProgress = false;
          console.error("err", err);
        });
    },
    getCategoryId(categoryName){
      return this.networkPageContent.networkPageCategories.find(category => category.value.toLowerCase() === categoryName.toLowerCase()).categoryId;
    },

  },
  computed: {
    ...mapGetters({
      communityInfo: `chapter/${storeGetters.communityInfo}`,
      networkPageContent: `network/${storeGetters.networkPageContent}`,
      permissionsData: `auth/${storeGetters.permissionsData}`,
      isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
    }),
    isAddNewLinkDisabled() {
      return this.networkPageContent && this.networkPageContent.waysToEngage
        ? this.networkPageContent.waysToEngage.length >= 8
        : false;
    },
    isUrlRequired() {
      return this.resourceType === this.NetworkConstants.RESOURCES_SMALL || this.resourceType === this.NetworkConstants.WAYS_TO_ENGAGE_SMALL;
    },
    urlRules() {
      if (this.resourceType === this.NetworkConstants.RESOURCES_SMALL || this.resourceType === this.NetworkConstants.WAYS_TO_ENGAGE_SMALL) {
        return this.ypoNetworkValidationRules.NAVIGATION_URL_RULE;
      }
      return this.ypoNetworkValidationRules.HEADER_NAVIGATION_URL_RULE;
    },
    isFormValid() {
      if (this.$refs.resourceMenuDialog) {
        this.$refs.resourceMenuDialog.validate();
      }
      if (this.resourceType === NetworkConstants.RESOURCES_SMALL && (this.selectedResource || this.networkMenuEditModel.fileName)) {
        return this.valid;
      }

      if (this.resourceType === NetworkConstants.RELATED_CONTENT_SMALL) {
        const isValueValid = this.networkMenuEditModel.value && this.networkMenuEditModel.value.trim() !== '';
        const isFileValid = this.files.length > 0 || (this.networkMenuEditModel.fileName !== null && this.networkMenuEditModel.fileName.trim() !== '');
        return isValueValid && isFileValid;
      }

      return this.valid;
    },
    canEditContent() {
      if (this.permissionsData.canEditNetworkPageContent) {
        return true;
      }

      return (
        this.communityInfo &&
        this.communityInfo.communityId === this.$route.params.communityId &&
        this.communityInfo.userAccess &&
        this.communityInfo.userAccess.canEditNetworkPageContent
      );
    },
    isMobileOrSmall() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md;
    },
    isDraggableDisabled() {
      return !this.canEditContent || this.isMobileOrSmall;
    },
    aboutUsData(){
      return this.networkPageContent && this.networkPageContent.communityId && this.networkPageContent.aboutUs
          ? this.networkPageContent.aboutUs.value : "";
    },
    relatedContentSectionData(){
      return this.networkPageContent && this.networkPageContent.relatedContentSectionName ? this.networkPageContent.relatedContentSectionName.value : 'Related Content'; 
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/responsive.scss";

.networks-view {
  position: relative;
  background: white;
  justify-content: space-between;
  height: 100%;
  max-width: 2200px;
  margin: 25px auto 0;

  &__header {
    display: flex;
    margin-top: 50px;
    text-align: center;
    margin-left: 0;
  }

  &__centre_widgets {
    position: absolute;
    width: 100%;
  }

  &__about-us {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 30px;
    background-color: $ypo-cta-medium;
    margin-bottom: 35px;

    &--title {
      color: $ypo-blue;
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 25px;
      position: relative;
      width: 100%;
      display: inline-block;

      .about-us-edit-icon {
        font-size: 14px !important;
        color: $ypo-gray !important;
        cursor: pointer;
        position: absolute;
        display: none;
        right: calc(47% - 25px);
        top: 50%;
        transform: translateY(-50%);
        &:hover {
          color: $ypo-cta !important;
        }
      }

      &:hover .about-us-edit-icon {
        display: block;
        @include breakpoint(sm) {
          display: none;
        }
        @include breakpoint(md) {
          display: none;
        }
        @include breakpoint(lg) {
          display: none;
        }
      }
    }

    &--description {
      font-size: 14px;
      font-weight: 400;
      max-width: 1000px;
      line-height: 1.6;
    }
  }


  &__center-section {
    margin-top: 50px;

    @include breakpoint(xs) {
      padding: 20px;
      margin-top: 0;
    }

    @include breakpoint(sm) {
      padding: 20px;
      margin-top: 0;
    }
  }

  .resources-div {
    min-width: 100%;
    background-color: $ypo-cta-medium;
    padding: 20px 70px;
    display: flex;
    flex-direction: column;
    align-items: center;

    @include breakpoint(xs) {
      padding: 20px 0;
      border-radius: 15px;
    }

    @include breakpoint(sm) {
      padding: 20px 0;
      border-radius: 15px;
    }

    .resources-wrapper {
      display: flex;
      justify-content: center;
      width: 100%;

      @include breakpoint(xs) {
        flex-direction: column;
      }

      @include breakpoint(sm) {
        flex-direction: column;
      }
    }

    .resources-column {
      padding: 10px;

      @include breakpoint(xs) {
        width: 100%;
        margin-bottom: 10px;
      }

      @include breakpoint(sm) {
        width: 100%;
        margin-bottom: 10px;
      }

      &--add-btn {
        @include breakpoint(sm) {
          display: none;
        }
        @include breakpoint(lg) {
          display: none;
        }
        margin-top: 6px;
        background: none;
        color: $ypo-blue;
        font-size: 13px;
        font-weight: 600;
        text-transform: capitalize;
        cursor: pointer;
      }

      h3 {
        font-size: 20px;
        color: $ypo-blue;
        font-weight: 700;
        margin-bottom: 10px;

        @include breakpoint(xs) {
          text-align: left;
          margin-left: 20px;
        }

        @include breakpoint(sm) {
          text-align: left;
          margin-left: 20px;
        }

        @include breakpoint(sm) {
          text-align: left;
          margin-left: 20px;
        }
      }

      ul {
        list-style-type: none;
        padding: 0;

        @include breakpoint(xs) {
          text-align: left;
          padding-left: 20px;
        }

        @include breakpoint(sm) {
          text-align: left;
          padding-left: 20px;
        }

        li {
          font-size: 14px;
          display: flex;
          align-items: center;
          position: relative;
          padding-right: 25px;

          .link-container {
            padding-bottom: 2px;
            display: flex;
            align-items: center;
            width: 100%;

            a {
              flex: 1;
              white-space: normal;
            }

            i {
              font-size: 12px !important;
              color: $ypo-gray !important;
              cursor: pointer;
              position: relative;
              display: none;

              &:hover {
                color: $ypo-cta !important;
                ;
              }
            }

            &:hover {
              i {
                display: block;

                @include breakpoint(sm) {
                  display: none;
                }
              }
            }
          }

          .link {
            color: $ypo-cta;
            font-size: 16px;
            font-weight: 400;
            text-decoration: none;
            white-space: normal;
          }

          .link:hover {
            text-decoration: underline;
          }

          .no-link {
            color: $ypo-cta;
            font-size: 16px;
            font-weight: 400;
            text-decoration: none;
            white-space: normal;
            cursor: default;

            &:hover {
              text-decoration: none;
            }
          }
        }
      }

      p {
        font-size: 14px;
        margin-top: 10px;
        max-width: 270px;

        @include breakpoint(xs) {
          padding-left: 20px;
        }

        @include breakpoint(sm) {
          padding-left: 20px;
        }

        .link-bold {
          font-weight: bold;
          color: $ypo-cta;
          text-decoration: none;
        }

        .link-bold:hover {
          text-decoration: underline;
        }
      }

    }
  }

  .resources-list {
    display: flex;
    flex-wrap: wrap;

    @include breakpoint(xs) {
      flex-direction: column;
      align-items: flex-start;
    }

    @include breakpoint(sm) {
      flex-direction: column;
      align-items: flex-start;
    }

    li {
      flex-basis: 50%;
      display: flex;
      align-items: center;

      @include breakpoint(xs) {
        justify-content: flex-start;
        min-width: 270px;
        padding: 2px;
      }

      @include breakpoint(sm) {
        justify-content: flex-start;
        min-width: 270px;
        padding: 2px;
      }

      i {
        margin-right: 10px;
      }

      .link {
        text-decoration: none;
      }

      .link:hover {
        text-decoration: underline;
      }
    }
  }

  .related-content {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.industries-section {
  padding: 30px;
  background-color: white;
  text-align: center;

  .non-clickable {
    cursor: default;
    pointer-events: none;
    opacity: 1;
  }

  .industries-title {
    font-size: 24px;
    font-weight: 700;
    color: $ypo-blue;
    margin-bottom: 40px;
  }

  .industry-item {
    text-align: center;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 1 1 calc(20% - 40px);
    box-sizing: border-box;
    max-width: 280px; 

    &.no-link {
      cursor: default;
      .industry-image,
      .industry-name {
        cursor: default;
      }
    }

    i {
      font-size: 14px !important;
      color: $ypo-gray !important;
      cursor: pointer;
      position: absolute;
      top: 10px;
      right: 10px;
      display: none;
      z-index: 1;

      &:hover {
        color: $ypo-cta !important;
      }
    }

    &:hover {
      i {
        display: block;

        @include breakpoint(sm) {
          display: none;
        }
      }
    }
  }

  .industry-image {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 10px;
    cursor: pointer;
  }

  .industry-name {
    font-size: 16px;
    font-weight: 600;
    color: $ypo-cta;
    cursor: pointer;
  }

  .centered-single {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  &--add-btn {

    margin-top: 16px;
    margin-bottom: 16px;
    background: none;
    color: $ypo-blue;
    font-size: 13px;
    font-weight: 600;
    text-transform: capitalize;
    cursor: pointer;

    @include breakpoint(sm) {
      display: none;
    }
    @include breakpoint(md) {
      display: none;
    }
    @include breakpoint(lg) {
      display: none;
    }
  }

  .editable-title {
    position: relative;
    display: inline-block;
  }

  .edit-icon {
    @include breakpoint(sm) {
        display: none;
      }
      @include breakpoint(md) {
        display: none;
    }
    @include breakpoint(lg) {
        display: none;
    }
    position: absolute;
    right: -25px;
    bottom: 60%;
    transform: translateY(-50%);
    opacity: 0;
    transition: opacity 0.2s;
    font-size: 12px !important;
    color: $ypo-gray !important;
    &:hover {
      color: $ypo-cta !important;
    }
  }

    .editable-title:hover .edit-icon {
      opacity: 1;
    }
  }
}

.categoryEdit-popup {
  .v-card__title {
    background-color: $ypo-tile-border;
    color: $ypo-blue;
    font-family: Raleway, "sans-serif";
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    position: relative;

    i {
      color: $ypo-cta;
      position: absolute;
      right: 20px;
      cursor: pointer;
    }
  }

  .file-upload {
    padding: 8px 14px;

    * {
      cursor: pointer !important;
    }

    &:hover {
      background-color: $ypo-open-blue-gray !important;
    }
  }

  .item-img {
    height: 100px;
    width: 100px;
    border-radius: 10px;
  }

  .image-name {
    color: $ypo-blue;
    font-size: 14px;
    font-weight: bold;
    margin-left: 20px;
  }

  .resource-height {
    max-height: 550px;

    @include breakpoint(xs) {
      max-height: 450px;
    }

    @include breakpoint(sm) {
      max-height: 550px;
    }

    @include breakpoint(md) {
      max-height: 550px;
    }
  }

  .form-control {
    margin: 0 10px;
    min-height: 70px;
    position: relative;
  }

  .currently-work {
    position: absolute;
    right: 0;
  }

  .required-label {
    color: $ypo-blue;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    text-align: right;
    display: block;
  }

  .select-label {
    color: $ypo-blue;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;

    i {
      font-size: 18px;
      padding-left: 5px;
    }
  }

  .select-label-dateFeild {
    color: $ypo-blue;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    margin-left: 10px;

    i {
      font-size: 18px;
      padding-left: 5px;
    }
  }

  .error-label-enable {
    color: $ypo-red;
  }

  .error-label-disable {
    color: $ypo-blue;
  }

  h4 {
    color: $ypo-blue;
    font-family: Raleway, "sans-serif";
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    margin: 0 0 5px 10px;
  }

  .check-list {
    margin: 0 5px 10px 5px;
    border-bottom: 2px solid rgba($black, 0.2);
    padding: 10px 0 10px 0;
  }

  .row__list {
    margin-bottom: 20px;
  }

  .btn-row {
    padding: 0 0 30px 15px;

    @media (max-width: 767px) {
      .v-btn {
        padding: 7px 20px;
      }
    }

    @include breakpoint(xs) {
      padding: 10px 0 10px 0;
    }
  }

  .v-card__text {
    margin-right: 5px;
    width: auto;
  }

  .v-card__actions {
    border-top: 1px solid $ypo-medium-gray;
  }

  .details-view {
    color: $ypo-gray-text;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 30px;
    padding-top: 30px;
    border-top: 1px solid $ypo-medium-gray;

    &:first-child {
      border-top: none;
      padding-top: 0;
    }

    h6 {
      color: $ypo-blue;
      font-size: 16px;
      font-weight: bold;
      line-height: 22px;
      margin: 0 0 5px 0;

      i {
        color: $ypo-title-blue-gray;
        margin-left: 5px;
        cursor: pointer;
      }

      .note {
        font-size: 14px;
        color: $ypo-gray;
        font-weight: 500;
        margin: 0 0 0 15px;
      }
    }

    strong {
      margin-left: 20px;
      display: block;

      i {
        color: $ypo-title-blue-gray;
        cursor: pointer;
        margin-left: 5px;
      }
    }

    small {
      margin-left: 20px;
      font-size: 14px;
      display: block;
    }

    i {
      color: $ypo-title-blue-gray;
      font-size: 14px;
      margin-left: 5px;
      cursor: pointer;
    }
  }

  .contact-edit {
    &__title {
      color: $ypo_blue;
      text-align: center;
      font-weight: 600;
      line-height: 16px;
      font-size: 12px;
      margin-bottom: 15px;
    }

    &__row {
      align-items: center;
      background: $ypo-light-gray-background;

      &:nth-child(2n + 1) {
        background: $white;
      }

      strong {
        display: block;
        text-align: right;
        margin-top: 20px;
        color: $ypo_blue;
      }
    }
  }

  .autocomplete-svg svg {
    width: 12px !important;
    height: 12px !important;
    background: red;
  }

  .autocomplete {
    position: relative;

    .autocomplete-results {
      padding: 0;
      margin: 0;
      border: 1px solid $white;
      height: 200px !important;
      max-height: 200px !important;
      overflow: auto;
      background: $ypo-extra-light-gray;
      position: absolute;
      z-index: 100;
      width: 100%;
    }

    .autocomplete-result {
      list-style: none;
      text-align: left;
      padding: 4px 2px;
      cursor: pointer;

      &.is-active,
      &:hover {
        background-color: $ypo-cta;
        color: $black;
      }
    }
  }

  .v-btn__content {
    text-transform: uppercase;
  }

  .save-to-profile {
    display: initial;
    color: $ypo_blue;
    margin-left: 15px;
    font-weight: bold;

    i {
      margin-right: 8px;
    }

    @include breakpoint(xs) {
      display: block;
      margin: 10px 0;
    }
  }

  .add-edit-btn {
    position: relative;

    .fa-plus-circle {
      @include breakpoint(xs) {
      display: none;
    }
    @include breakpoint(sm) {
      display: none;
    }
    @include breakpoint(md) {
      display: none;
    }
    @include breakpoint(lg) {
      display: none;
    }
      position: absolute;
      left: 6px;
      bottom: 0;
      font-size: 9px !important;
      background: $white;
      border-radius: 50%;
      padding: 1px;
    }
  }

  .resources-column--add-btn.disabled {
    pointer-events: none;
  }

  .fas.fa-info-circle {
    color: #999;
    cursor: pointer;
  }

  .drag-area {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .drag-area li {
    cursor: move;
    margin-bottom: 10px;
  }

  .ghost {
    opacity: 0.4;
  }
}
</style>
